import axios from '@/api/axios'
// import _ from 'lodash'

const apiUrlEx = '/v1/history'

const list = async (curPage, sk, result) => {
  let finalData = {
    items: {},
    totalPage: 0
  }
  const options = {
    method: 'GET',
    url: apiUrlEx,
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: {
      page: curPage,
      sk: sk
    }
  }

  await axios(options)
    .then((response) => {
      if (response.data.code === 100) {
        finalData.items = response.data.data
        finalData.totalPage = response.data.paginate.totalPage
        result(finalData)
      } else {
        result(null)
      }
    })

}

export default {
  list
}

export {}
